import { TagOutlined } from '@ant-design/icons'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { ConditionalWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Space, Tag, Tooltip, Typography } from 'antd'
import { FC } from 'react'
import { Coupon as CouponModel } from '../../../models/membership/Coupon'
import { useAppSelector } from '../../../store/hooks'
import { selectCouponById } from '../../../store/membership/CouponReducer'
import { currencyFormat } from '../../../utils/currencyFormatter'

const { Text } = Typography

type Props = SBModelComponent<CouponModel> & {
  showDetails?: boolean
}

const CouponAvatar: FC<Props> = ({ id, model, showDetails = false }) => {
  const item = model ? model : useAppSelector(selectCouponById(id!))

  if (!item) {
    return <></>
  }

  return (
    <ConditionalWrapper
      condition={showDetails}
      wrapper={(children) => (
        <Tooltip
          title={
            <Space>
              {item.code}
              {item.useOnlyOnFirstCycle === true
                ? '- Only on first cycle'
                : '- Lifetime'}
            </Space>
          }
        >
          {children}
        </Tooltip>
      )}
    >
      <Tag icon={<TagOutlined />}>
        {showDetails
          ? item.fullAmount
            ? '100%'
            : currencyFormat(item.fixedAmount, true, true, true)
          : item.code}
      </Tag>
    </ConditionalWrapper>
  )
}

type CouponAvatarType = { Avatar: typeof CouponAvatar }

export { CouponAvatar, type CouponAvatarType }
